import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import { DatePicker } from '@/components/ui/date-picker'
import { PromotionFormData } from './promotion-form'

export const PromotionSchedulingCard = () => {
    const { t } = useTranslation('stores')
    const { watch, setValue: rawSetValue, formState: { errors } } = useFormContext<PromotionFormData>()
    const setValue: typeof rawSetValue = (name, value, options) =>
        rawSetValue(name, value, { shouldDirty: true, ...options })

    const startDate = watch('startDate')
    const endDate = watch('endDate')

    return (
        <Card>
            <CardHeader>
                <CardTitle>{t('promotion.scheduling.title')}</CardTitle>
                <p className="text-muted-foreground mt-1 text-sm">
                    {t('promotion.scheduling.description')}
                </p>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <Label htmlFor="startDate" className="text-xs">
                            {t('promotion.fields.startDate')}
                        </Label>
                        <DatePicker
                            value={startDate}
                            onChange={(date) => setValue('startDate', date ?? null)}
                            placeholder={t('promotion.fields.noStartDate')}
                            error={!!errors.startDate}
                        />
                    </div>
                    <div>
                        <Label htmlFor="endDate" className="text-xs">
                            {t('promotion.fields.endDate')}
                        </Label>
                        <DatePicker
                            value={endDate}
                            onChange={(date) => setValue('endDate', date)}
                            placeholder={t('promotion.fields.noEndDate')}
                            error={!!errors.endDate}
                        />
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}
